import { useFrame } from '@react-three/fiber';
import { useMemo } from 'react';
import { createGetOrbitECC } from 'src/threejs/components/OrbitManager/store/getters';
import { MarkerProps } from 'src/types';
import { Vector3 } from 'three';
import Marker from '../../../Marker';
import { use3DOrbitContext } from '../../context';
import ECCMarkerHandle from './ECCMarkerHandle';

/** The non-static True Motion Anomaly marker */
const EccMarker = ({ handle, setHandle, marker, setMarker }: MarkerProps) => {
  const { id, size } = use3DOrbitContext();
  const getOrbitECC = useMemo(() => createGetOrbitECC(id), [id]);

  const scale = useMemo(() => new Vector3().setScalar(size / 50), [size]);

  useFrame(() => {
    const { x, y, z } = getOrbitECC();

    if (marker) {
      marker.position.set(x, y, z);
    }
  });

  return (
    <>
      <Marker
        marker={marker}
        setMarker={setMarker}
        markerName="ECC Marker"
        scale={scale}
      >
        <sphereGeometry />
        <meshBasicMaterial
          color={0xff0000}
          transparent={true}
          opacity={0.75}
          depthWrite={false}
        />
      </Marker>
      <ECCMarkerHandle
        handle={handle}
        setHandle={setHandle}
      />
    </>
  );
};

export default EccMarker;
